var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"1300px"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('Accounts'),_c('v-card',[_c('v-card-actions',[_c('v-btn',{attrs:{"outlined":"","color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.show=false}}},[_vm._v("Close")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }